import { useState } from 'react'
import { EmojiPicker } from './EmojiPicker'
import { GifPicker } from './GifPicker'
import { StickerPicker } from './StickerPicker'

type Tab = 'emoji' | 'gif' | 'sticker'

interface Props {
  onEmoji: (emoji: string) => void
  onGif: (url: string) => void
  onSticker: (fileId: string, emoji: string) => void
  onClose: () => void
}

export function MediaPickerPanel({ onEmoji, onGif, onSticker, onClose }: Props) {
  const [tab, setTab] = useState<Tab>('emoji')

  return (
    <div className="absolute bottom-full mb-2 left-0 z-50 animate-fade-in">
      {/* Tab bar */}
      <div className="flex bg-bg-primary border border-b-0 border-divider rounded-t-2xl overflow-hidden">
        {([
          { id: 'emoji' as Tab, label: '😊', title: 'Эмодзи' },
          { id: 'gif'   as Tab, label: 'GIF', title: 'GIF' },
          { id: 'sticker' as Tab, label: '🎭', title: 'Стикеры' },
        ] as const).map(({ id, label, title }) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            title={title}
            className={`flex-1 py-2 text-sm font-medium transition-colors
              ${tab === id
                ? 'text-accent border-b-2 border-accent'
                : 'text-txt-secondary hover:text-txt-primary border-b-2 border-transparent'}`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Panel content — each picker is absolute-positioned relative to itself */}
      <div className="relative">
        {tab === 'emoji' && (
          <EmojiPicker
            onSelect={onEmoji}
            onClose={onClose}
            inline
          />
        )}
        {tab === 'gif' && (
          <GifPicker
            onSelect={onGif}
            onClose={onClose}
            inline
          />
        )}
        {tab === 'sticker' && (
          <StickerPicker
            onSelect={onSticker}
            onClose={onClose}
            inline
          />
        )}
      </div>
    </div>
  )
}
